import styled from 'styled-components'

function BaseInsertDriveFileOutlinedIcon({ className, size = 24, ...rest }: IconComponentProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zM6 20V4h7v5h5v11z"
        fill="currentColor"
      />
    </svg>
  )
}

export const InsertDriveFileOutlinedIcon = styled(BaseInsertDriveFileOutlinedIcon)``
